import * as React from 'react'

import { Typography } from '@material-ui/core'
import IMeasuredMetric from '../../../data/abitilies/interfaces/IMeasuredMetric'

import { getLastWordFromString } from 'services/utils'
import './styles.scss'

import { getValueClassName } from 'data/abitilies/Breakpoint'
import { transformMeasureMetric } from 'services/normativeData'

interface IProps {
  metric: IMeasuredMetric
  talentMap: any
  isPlusUser: boolean
  relevantAssessment: number
  birhtDate: number
  goToPlus: () => void
}
interface IState {
  infoOpen: boolean
}

export class MeasuredMetric extends React.Component<IProps, IState> {
  state = {
    infoOpen: false
  }

  toggleInfo = () =>
    this.setState(prevState => ({ infoOpen: !prevState.infoOpen }))

  displayMetricValueByLabel = (object: object, label: string = '') => {
    const { relevantAssessment, goToPlus, birhtDate } = this.props
    const transformedValue = label.replace(/-|\s/gi, '_').toLowerCase()

    // const plusAbility = [
    //   'planning', 'inhibition',
    //   'visual_spatial_short_term_memory', 'visual_spatial_working_memory',
    //   'hyperactivity', 'continuous_performance_attention',
    //   'non_symbolic_numerical_representation', 'symbolic_numerical_representation', 'enumeration'
    // ]
    const exceptionsList = ['spatial_abilities', 'emotional', 'social']
    const toHideValue = !this.props.isPlusUser // && plusAbility.includes(transformedValue)
    // console.log(transformedValue)

    const val =
      toHideValue && !exceptionsList.includes(transformedValue)
        ? false
        : Object.keys(object || {}).some(v => v === transformedValue)
    const transformedMetricValue = val
      ? transformMeasureMetric(
          label,
          object[transformedValue],
          birhtDate,
          relevantAssessment
        )
      : -1
    const freemium =
      !this.props.isPlusUser &&
      Object.keys(object || {}).some(v => v === transformedValue)

    return val ? (
      <span
        className={`${getValueClassName(
          transformedMetricValue
        )} measured-metric__score`}
      >
        {`${Math.ceil(transformedMetricValue)}%`}
      </span>
    ) : (
      freemium && (
        <span className="measured-metric__freemium" onClick={goToPlus}>
          Ready
        </span>
      )
    )
  }

  render() {
    const {
      metric: { label, storeKey, description },
      talentMap
    } = this.props
    const { infoOpen } = this.state

    const { last, rest } = getLastWordFromString(label)

    return (
      <div className="measured-metric design-fixes">
        <Typography
          classes={{ root: 'measured-metric-title' }}
          className={'label' + (infoOpen ? ' active' : '')}
          onClick={this.toggleInfo}
        >
          <span>
            {rest}
            {rest && last && ' '}
            <span className="last-word">
              {last}
              <img
                src={require('../../../assets/img/more_black.svg')}
                alt=""
                className={'more-img' + (infoOpen ? ' active' : '')}
              />
            </span>
          </span>
          {this.displayMetricValueByLabel(talentMap, storeKey)}
        </Typography>
        <div className={'info' + (infoOpen ? ' active' : '')}>
          <Typography className="description">{description}</Typography>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Abilities/MeasuredMetric/index.tsx